import { Colors } from "./common.theme";

export const colors: Colors = {
  background: {
    default: "#16181c",
    card: "#000000",
    header: "#000000",
    disableButton: "#16181c",
    transparent: "rgba(255, 255, 255, 0.024)",
    mention: "#000",
    selectedpoll: "rgb(12 50 93 / 75%)",
  },
  color: {
    default: "#f1f2f3",
    title: "#F1F2F3",
    subtitle: "#bdbdbd",
  },
  mention: {
    background: "#000",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    focusColor: "#2196f3",
  },
  poll: {
    background: "rgba(255, 255, 255, 0.072)",
  },
};
